import { environment } from "../environments/environment";

export class GlobalConstants {
  canalCanonico: any;
  arrayConstants: any = {
    tribunanoticias: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: true,
      siteTitle: "Noticias - Tribuna",
      siteName: "Tribuna Noticias.",
      navTitle: "Información veraz ",
      navImg: "logo-esp-mapa.webp",
      metaTag: "Noticias sobre España. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital.",
      idAmbito: 14,
      nombreCiudad: "España",
      siteDomain: "https://www.tribunanoticias.es",
      seccionPrincipal: "seccion/143/nacional",
      logoMain: "logo-tribuna-news.webp",
      logoMovil: "logo-tribuna-menu-news.webp",
      imgShare: "logo-tribuna-news.webp",
      idPublicidad: 94,
      idCartaDirector: 142,
      idAnalytic: "G-W4JCPBWBN8",
      fondoBloqueBlogs: "",
      imagenIconoCuadrado: "",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#5317AF",
      tagGTM: "GTM-NHZJJWZ8",
    },
    tribunaavila: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: "Noticias Ávila - Tribuna",
      siteName: "Tribuna de Ávila.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre Ávila y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de Ávila.",
      idAmbito: 6,
      nombreCiudad: "Ávila",
      siteDomain: "https://www.tribunaavila.com",
      seccionPrincipal: "",
      logoMain: "logo-tribuna-avila.webp",
      logoMovil: "logo-tribuna-menu-avila.webp",
      imgShare: "logo-tribuna-avila.webp",
      idPublicidad: 85,
      idCartaDirector: 31,
      idAnalytic: "G-8HPFXNTPL3",
      codigoTiempo: "05019",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-avila.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-avila.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#eab630",
      tagGTM: "GTM-NHZJJWZ8",
    },
    tribunaburgos: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: " Noticias Burgos - Tribuna",
      siteName: "Tribuna de Burgos.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre Burgos y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de Burgos.",
      idAmbito: 8,
      nombreCiudad: "Burgos",
      siteDomain: "https://www.tribunaburgos.com",
      seccionPrincipal: "seccion/29/burgos",
      logoMain: "logo-tribuna-burgos.webp",
      logoMovil: "logo-tribuna-menu-burgos.webp",
      imgShare: "logo-tribuna-burgos.webp",
      idPublicidad: 82,
      idCartaDirector: 38,
      idAnalytic: "G-3P019T8ZRP",
      codigoTiempo: "09059",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-burgos.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-burgos.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#b62622",
      tagGTM: "GTM-NHZJJWZ8",
    },

    tribunaleon: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: "Noticias León - Tribuna",
      siteName: "Tribuna de León.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre León y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de León.",
      idAmbito: 3,
      nombreCiudad: "León",
      siteDomain: "https://www.tribunaleon.com",
      seccionPrincipal: "seccion/1/leon",
      logoMain: "logo-tribuna-leon.webp",
      logoMovil: "logo-tribuna-menu-leon.webp",
      imgShare: "logo-tribuna-leon.webp",
      idPublicidad: 80,
      idCartaDirector: 39,
      idAnalytic: "G-JJ1SLN327G",
      codigoTiempo: "24089",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-leon.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-leon.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#764731",
      tagGTM: "GTM-NHZJJWZ8",
    },

    tribunapalencia: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: "Noticias Palencia - Tribuna",
      siteName: "Tribuna de Palencia.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre Palencia y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de Palencia.",
      idAmbito: 7,
      nombreCiudad: "Palencia",
      siteDomain: "https://www.tribunapalencia.com",
      seccionPrincipal: "seccion/81/palencia",
      logoMain: "logo-tribuna-palencia.webp",
      logoMovil: "logo-tribuna-menu-palencia.webp",
      imgShare: "logo-tribuna-palencia.webp",
      idPublicidad: 81,
      idCartaDirector: 35,
      idAnalytic: "G-TZ9PFJB8CP",
      codigoTiempo: "34120",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-palencia.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-palencia.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#383976",
      tagGTM: "GTM-NHZJJWZ8",
    },

    tribunasalamanca: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: "Noticias Salamanca - Tribuna",
      siteName: "Tribuna de Salamanca.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre Salamanca y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de Salamanca.",
      idAmbito: 5,
      nombreCiudad: "Salamanca",
      siteDomain: "https://www.tribunasalamanca.com",
      seccionPrincipal: "",
      logoMain: "logo-tribuna-salamanca.webp",
      logoMovil: "logo-tribuna-menu-salamanca.webp",
      imgShare: "logo-tribuna-salamanca.webp",
      idPublicidad: 86,
      idCartaDirector: 33,
      idAnalytic: "G-DYX8MNKHXG",
      codigoTiempo: "37274",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-salamanca.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-salamanca.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#e8b436",
      tagGTM: "GTM-NHZJJWZ8",
    },

    tribunasegovia: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: "Noticias Segovia - Tribuna",
      siteName: "Tribuna de Segovia.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre Segovia y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de Segovia.",
      idAmbito: 10,
      nombreCiudad: "Segovia",
      siteDomain: "https://www.tribunasegovia.com",
      seccionPrincipal: "seccion/42/segovia",
      logoMain: "logo-tribuna-segovia.webp",
      logoMovil: "logo-tribuna-menu-segovia.webp",
      imgShare: "logo-tribuna-segovia.webp",
      idPublicidad: 84,
      idCartaDirector: 37,
      idAnalytic: "G-0HWGRK7QCR",
      codigoTiempo: "40194",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-segovia.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-segovia.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#ceac3f",
      tagGTM: "GTM-NHZJJWZ8",
    },

    tribunasoria: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: "Noticias Soria - Tribuna",
      siteName: "Tribuna de Soria.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre Soria y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de Soria.",
      idAmbito: 9,
      nombreCiudad: "Soria",
      siteDomain: "https://www.tribunasoria.com",
      seccionPrincipal: "seccion/68/soria",
      logoMain: "logo-tribuna-soria.webp",
      logoMovil: "logo-tribuna-menu-soria.webp",
      imgShare: "logo-tribuna-soria.webp",
      idPublicidad: 83,
      idCartaDirector: 32,
      idAnalytic: "G-1M8TM2JBE7",
      codigoTiempo: "42173",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-soria.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-soria.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#9ebf56",
      groupName: "TRIBUNA",
      tagGTM: "GTM-NHZJJWZ8",
    },

    tribunavalladolid: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: "Noticias Valladolid - Tribuna",
      siteName: "Tribuna de Valladolid.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre Valladolid y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de Valladolid.",
      idAmbito: 2,
      nombreCiudad: "Valladolid",
      siteDomain: "https://www.tribunavalladolid.com",
      seccionPrincipal: "",
      logoMain: "logo-tribuna-valladolid.webp",
      logoMovil: "logo-tribuna-menu-valladolid.webp",
      imgShare: "logo-tribuna-valladolid.webp",
      idPublicidad: 88,
      idCartaDirector: 34,
      idAnalytic: "G-WCLR8R4BTL",
      codigoTiempo: "47186",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-valladolid.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-valladolid.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#8d5b9d",
      tagGTM: "GTM-NHZJJWZ8",
    },
    migracion: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/fecazanews",
      isNews: false,
      siteTitle: "Noticias Valladolid - Castilla y León | Tribuna Valladolid",
      siteName: "Tribuna de Valladolid.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre Valladolid y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de Valladolid.",
      idAmbito: 2,
      nombreCiudad: "Valladolid",
      siteDomain: "https://www.tribunavalladolid.com",
      seccionPrincipal: "",
      logoMain: "logo-tribuna-valladolid.webp",
      logoMovil: "logo-tribuna-menu-valladolid.webp",
      imgShare: "logo-tribuna-valladolid.webp",
      idPublicidad: 88,
      idCartaDirector: 34,
      idAnalytic: "UA-134286694-6",
      codigoTiempo: "47186",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-valladolid.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-valladolid.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#8d5b9d",
      tagGTM: "GTM-NHZJJWZ8",
    },

    tribunazamora: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: "Noticias Zamora - Tribuna",
      siteName: "Tribuna de Zamora.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre Zamora y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de Zamora.",
      idAmbito: 4,
      nombreCiudad: "Zamora",
      siteDomain: "https://www.tribunazamora.com",
      seccionPrincipal: "seccion/55/zamora",
      logoMain: "logo-tribuna-zamora.webp",
      logoMovil: "logo-tribuna-menu-zamora.webp",
      imgShare: "logo-tribuna-zamora.webp",
      idPublicidad: 87,
      idCartaDirector: 36,
      idAnalytic: "G-NNBTG2RNTB",
      codigoTiempo: "49275",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-zamora.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-zamora.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      codigoAdsense: "ca-pub-5378834401301137",
      color: "#852a7a",
      tagGTM: "GTM-NHZJJWZ8",
    },

    laverdaddesnuda: {
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: true,
      siteTitle: "La Verdad Desnuda",
      siteName: "La Verdad Desnuda",
      navTitle: "",
      navImg: "mapa-lvd-azul.webp",
      metaTag: "La Verdad Desnuda",
      idAmbito: 15,
      nombreCiudad: "La Verdadd Desnuda",
      siteDomain: "https://www.laverdaddesnuda.es",
      seccionPrincipal: "",
      logoMain: "logo-la-verdad-desnuda.webp",
      logoMovil: "logo-la-verdad-desnuda-menu.webp",
      idPublicidad: null,
      idCartaDirector: null,
      idAnalytic: "",
      codigoTiempo: "49275",
      fondoBloqueBlogs: "",
      imagenIconoCuadrado: "",
      codigoAdsense: "",
      color: "",
    },

    tribunamadrid: {
      gfk: true,
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: "Noticias Madrid - Tribuna",
      siteName: "Tribuna Madrid",
      navTitle: "",
      navImg: "",
      metaTag: "Tribuna Madrid",
      logoMovil: "logo-tribuna-menu-madrid.webp",
      idAmbito: 16,
      nombreCiudad: "Tribuna Madrid",
      siteDomain: "https://www.tribunamadrid.es",
      seccionPrincipal: "",
      idPublicidad: 142,
      idCartaDirector: null,
      idAnalytic: "G-KN9GWNV47L",
      codigoTiempo: "49275",
      fondoBloqueBlogs: "",
      imagenIconoCuadrado: "",
      codigoAdsense: "",
      color: "#db3035",
      tagGTM: "GTM-NHZJJWZ8",
    },
    pretribuna: {
      urlApi: "https://tribuna.isquad.es/ws/apitribuna",
      urlSharedApi: "https://tribuna.isquad.es/ws/apiprensa",
      isNews: false,
      siteTitle: "PreTribuna Valladolid",
      siteName: "Tribuna de Valladolid.",
      navTitle: "El primer diario digital de Castilla y León",
      navImg: "logo-cyl-mapa.webp",
      metaTag: "Noticias sobre Valladolid y su provincia. Deportes, sucesos, cultura, economía, empresas, en tu periódico digital de Valladolid.",
      idAmbito: 2,
      nombreCiudad: "Valladolid",
      siteDomain: "https://www.tribunavalladolid.com",
      seccionPrincipal: "",
      logoMain: "logo-tribuna-valladolid.webp",
      logoMovil: "logo-tribuna-menu-valladolid.webp",
      imgShare: "logo-tribuna-valladolid.webp",
      idPublicidad: 88,
      idCartaDirector: 34,
      idAnalytic: "UA-134286694-6",
      codigoTiempo: "47186",
      fondoBloqueBlogs: "/assets/images/fondo-contenedor-blogs-valladolid.webp",
      imagenIconoCuadrado: "/assets/images/logo-cuadrado-valladolid.webp",
      imagen404: "/assets/images/tribuna-404.webp",
      color: "#db3035",
      groupName: "TRIBUNA",
      email: "administracion@tribunagrupo.com",
      tagGTM: "GTM-NHZJJWZ8",
    },
  };

  constructor(private host) {
    if (host == "all") {
      return this.arrayConstants;
    }
    if (host.includes("localhost") || host.includes("192.168.") || host.includes("192.168.") || host.includes("toools.es")) {
      host = environment.name;
      if (host == "tribuna") {
        host = "tribunavalladolid";
      }
      return this.arrayConstants[host];
    }
    if (host.includes("pretribuna")) {
      host = "pretribuna";
    }

    return this.arrayConstants[host.split(".")[host.split(".").findIndex((v) => v.includes("tribuna"))]];
  }
}
